module.exports = __webpack_public_path__ + "img/CJ_BERTHOLLET_10s.e5bd8e40.jpg";